<template>
  <div>
    <div class="export-item search-input-section-item" v-for="(item, index) in data" :key="'export-col-item-' + index">
      <div v-if="item.areas && item.areas.length > 0">
        <div class="export-item-title">{{item.name}}</div>
        <Row :gutter="15">
          <Col
            span="6"
            :class="['ellipsis', {active: _.trim(activeName) === _.trim(_item.name)}]"
            v-for="(_item, _index) in item.areas"
            :key="'export-col-item-' + index + '-' + _index">
            <a href="#" :_id="_item.id" @click.prevent="selectItem">{{_item.name}}</a>
          </Col>
        </Row>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ExportDropdownItem',
  props: ['data', 'activeName'],
  methods: {
    selectItem (event) {
      this.$emit('selectItem', event)
    }
  }
}
</script>
<style scoped>
  .export-item-title{
    color: #aaa;
    margin-bottom: 5px;
    /*font-size: 10px;*/
    font-size: 12px;
  }
</style>



// WEBPACK FOOTER //
// src/components/common/ExportDropdownItem.vue